export default __webpack_public_path__ + "static/media/armaIcon.2e8f332f.png";